import {Component, Input, OnInit} from '@angular/core';
import {NavController} from '@ionic/angular';

@Component({
    selector: 'app-follower-list',
    templateUrl: './follower-list.component.html',
    styleUrls: ['./follower-list.component.scss'],
    standalone: false
})
export class FollowerListComponent implements OnInit {
  @Input() item;

  impactScoreVisible: number;

  constructor(private navController: NavController) {
  }

  ngOnInit() {
    this.impactScoreVisible = this.item?.impactScore ? this.item?.impactScore : 0;
    if (this.impactScoreVisible > 99.99 && !Number.isInteger(this.impactScoreVisible)) {
      this.impactScoreVisible = Math.floor(this.impactScoreVisible);
    }
  }

  openOtherProfile(id) {
    this.navController.navigateForward(['/app/home/other-profile/' + id]);
  }
}
